export default "__VITE_ASSET__BU6P9wa2__"